import { useSearchParams } from 'next/navigation'
import { type FC } from 'react'

import { LoginRegistrationUserTwoStepLoginContent } from '../../experiments/login-two-step/components/LoginRegistrationUserTwoStepLoginContent'
import { useShouldUseTwoStepLogin } from '../../experiments/login-two-step/useShouldUseTwoStepLogin'
import {
  LoginRegistrationUserLoginContent,
  resolveLoginOrigin,
  useGetRedirectToTargetPageAfterLogin,
  useLoginTracking,
} from '../../login-registration'

export const LoginRegistrationLoginSection: FC = () => {
  const origin = resolveLoginOrigin(useSearchParams())
  const redirectToTargetPage = useGetRedirectToTargetPageAfterLogin()
  const afterLoggedIn = useLoginTracking({
    afterLoggedIn: redirectToTargetPage,
    origin,
  })
  const shouldUseTwoStepLogin = useShouldUseTwoStepLogin()
  const loginContent = shouldUseTwoStepLogin ? (
    <LoginRegistrationUserTwoStepLoginContent afterLoggedIn={afterLoggedIn} />
  ) : (
    <LoginRegistrationUserLoginContent afterLoggedIn={afterLoggedIn} />
  )

  return (
    <div className="z-10 basis-1/2 tablet:mb-6 tablet:ml-6 tablet:mr-3">
      <div className="flex-1 bg-light-primary-low p-5 shadow-m tablet:rounded-m tablet:px-5">
        {loginContent}
      </div>
    </div>
  )
}
